import f from "../../../../funcs";
import Backbone from "backbone";


let ControlsModel = Backbone.Model.extend("ControlsModel", {
    defaults: {
        runned: false,
        play: false,
        captureLoading: false,
        offsetLeft: 0,
        offsetTop: 0,
        offsetWidth: 0,
        offsetHeight: 0,
        ratio: 0
    },

    getCrop(size, rect, resolution) {
        size = f.deepClone(size);
        // сначала масштабируем офсеты до размера камеры
        // и преобразуем "offset[W/H]" в нормальный w/h
        let rectScale = resolution.width / rect.width;
        let top = this.get("offsetTop");
        let left = this.get("offsetLeft");
        let width = rect.width + this.get("offsetWidth");
        let height = rect.height + this.get("offsetHeight");

        top *= rectScale;
        left *= rectScale;
        width *= rectScale;
        height *= rectScale;

        let crop = {
            top,
            left,
            width,
            height,
            scale: 1
        };

        if ( +size.width && +size.height ) {
            crop.scale = size.width / crop.width;
            crop.outWidth = +size.width;
            crop.outHeight = +size.height;
        }

        return crop;
    }
});

export default ControlsModel;
